import { EAttachmentType, ETaxonomy, ICardBenefitPackage } from "library/types";

import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";

export function useIsSalaryDeductionConsentGivenNew(benefitPackage: ICardBenefitPackage) {
  const salaryDeductionAttachmentType = useTaxonomyOptions(ETaxonomy.AttachmentType)?.find(
    (item) => item.code === EAttachmentType.SALARY_DEDUCTION
  )?.value;

  const config = benefitPackage.enrollmentDocuments?.find((doc) => {
    return (
      doc.attachmentType === salaryDeductionAttachmentType &&
      benefitPackage.employeeEnrollmentTag?.toString() === doc.attachmentObjectTag?.toString()
    );
  });
  return !!config;
}
